import type { DeviceContextFields } from 'src/store/DeviceContext/types';

import { getCachedDeviceBattery } from './device-battery-metadata';

/** Shared wire names for authenticated requests and optional health metadata. */
export function buildDeviceIdentityHeaders(
  context: Partial<DeviceContextFields>,
  currentDeviceType?: string,
  businessName?: string
): Record<string, string | undefined> {
  return {
    'X-Current-Device': context.businessDeviceId ?? '',
    'X-Business-Device-Id': context.businessDeviceId ?? '',
    'X-Business-Location-Id': context.businessLocationId ?? undefined,
    'X-Terminal-Id': context.terminalId ?? undefined,
    'X-Device-Fingerprint': context.deviceFingerprint ?? undefined,
    'X-Public-Key-Fingerprint': context.publicKeyFingerprint ?? undefined,
    'X-Business-Name': businessName
      ? encodeURIComponent(businessName).replace(/%20/g, ' ')
      : undefined,
    'X-Business-Id': context.businessId ?? undefined,
    'X-Current-Device-Type': currentDeviceType,
  };
}

export function encodeDeviceContextHeaders(context: object): Record<string, string> {
  const battery = getCachedDeviceBattery();
  const payload = battery ? { ...context, battery } : context;
  // Encode UTF-8 bytes, not UTF-16 code units: names can contain any language.
  const encoded = btoa(
    encodeURIComponent(JSON.stringify(payload)).replace(/%([0-9A-F]{2})/g, (_match, hex) =>
      String.fromCharCode(parseInt(hex, 16))
    )
  );
  return {
    'X-Current-Device-data': encoded,
    'X-Device-Context-data': encoded,
    'X-Current-Device-data-encoding': 'base64',
  };
}
